import {connect}      from 'react-redux';
import dataThunks     from '../../store/actions/dataThunks';
import langueActions  from '../../store/actions/langueActions';

const mapStateToProps = (state) => ({
  isLoadingTemplates : state.getIn(['langue', 'isLoadingTemplates']),
  templates          : state.getIn(['langue', 'templates']),
  tempTemplates      : state.getIn(['langue', 'tempTemplates']),
});

const mapDispatchToProps = (dispatch) => ({
  getTemplates() {
    dispatch(dataThunks.getTemplates());
  },
  editTemplates(templates) {
    dispatch(langueActions.editTemplates(templates));
  },
  setTemplates(lang) {
    dispatch(dataThunks.setTemplates(lang));
  },
  updateTempTemplates(templates) {
    dispatch(langueActions.updateTempTemplates(templates));
  },
});

const buildController = (component) => connect(mapStateToProps, mapDispatchToProps)(component);

export default buildController;




// WEBPACK FOOTER //
// ./src/organisms/MainAdmin/MainAdminController.js